import React from 'react';
import { mergeClassNames } from '../../../utils';
import styles from './index.module.scss';

export default function SVGIcon({ svgIcon, className = null, style = null }) {
  let { file = {}, svg } = svgIcon || {};

  // see gatsby-transformer-inline-svg
  if (file.contentType === 'image/svg+xml' && svg && svg.content) {
    return (
      <div
        className={mergeClassNames(styles.inlinedSvg, className)}
        dangerouslySetInnerHTML={{ __html: svg.content.replace(/fill="(.)+?"/g, '') }}
      />
    );
  }

  return (
    <img
      className={className}
      style={style}
      alt={svgIcon?.description}
      src={file?.url}
      width={file?.details?.image?.width}
      height={file?.details?.image?.height}
    />
  );
}
